import { VStack, Box, BoxProps } from '@chakra-ui/react'
import * as React from 'react'

import { TextBody, TextBodyBold2, TextHeadline1 } from '../common/Text'
import { vw } from '../../styles/theme'

export type TopCreditProps = BoxProps & {}

const TopCredit: React.FC<TopCreditProps> = ({ ...others }) => {
  return (
    <>
      <Box pt={[vw(150), '200px']} {...others}>
        <Box w={['contentSP', '660px']} m="0 auto" textAlign={['center', 'left']}>
          <Box mb={[vw(60), '60px']}>
            <TextHeadline1 as="h2" localizeKey="top__credit__title" lineHeight="1" />
          </Box>

          <VStack alignItems={['center', 'flex-start']} spacing={[vw(60), '30px']}>
            {Array(4)
              .fill(0)
              .map((_, i) => {
                const num = i + 1
                return (
                  <Box key={i}>
                    <TextBodyBold2 localizeKey={`top__credit__content_title_${num}`} />
                    <TextBody localizeKey={`top__credit__content_body_${num}`} />
                  </Box>
                )
              })}
          </VStack>
        </Box>
      </Box>
    </>
  )
}

export default TopCredit
